<div class="container px-4 pb-4">
  <!--<div class="px-4 mt-2">
  <button class="btn-inverse py-1" (click)="goBack()">
  < Back</button>
</div>-->
<app-shared-action-bar [saveReady]="unsavedChanges" [undoReady]="unsavedChanges"
  [displayActionSectionBar]="showActionSectionBar" (saveRequest)="startSave()"
(undoRequest)="resetPermissionView()"></app-shared-action-bar>
<div class="mt-20 pb-4 mx-4">
  @if (!isGroup) {
    <h2 class="settings-header">Location User Permissions</h2>
  }
  @if (isGroup) {
    <h2 class="settings-header">Location Group Permissions</h2>
  }
</div>
<div class="p-4">
  <div class="" [ngClass]="{'p-3 border-grey-500 border-2 rounded-md':!collapseSearch}">
    @if (collapseSearch && loadComplete) {
      <div class="flex items-center">
        <p class="settings-selected-item">
          {{selectedLocation.LocationName}}
        </p>
        @if (includeSubLocations) {
          <p class="ml-2 settings-selected-item">(w/Sub
          Locations)</p>
        }
        <span class="text-center material-symbols-outlined text-xl md:text-2xl hover:cursor-pointer ml-2 "
        (click)="showSearch()">edit</span>
      </div>
    }
    @if (!collapseSearch) {
      <div>
        <div class="justify-between flex ">
          <h3 class="mb-5 mt-3">Select Location</h3>
          <button class="btn-inverse self-center" (click)="resetLocations()">Reset Locations</button>
        </div>
        @if (locationsReady) {
          <div>
            @for (l of possibleLocations; track l) {
              <div class="flex w-full my-2">
                <span
                  class="p-2 md:p-4 flex-grow standardTextSize border-spacing-1.5 border-b-grey-500 border-s-2 flex  align-middle hover:hover-for-select"
                  [ngClass]="{'selected': l.LocationID == selectedLocation.LocationID, 'hover:hover-for-select  ':l.HasPermission, 'bg-grey-100 hover:cursor-not-allowed':!l.HasPermission,' bg-grey-300':l.HasPermission&&l.LocationID!=selectedLocation.LocationID}"
                  (click)="selectLocation(l)">{{l.LocationName}}@if (!l.Active) {
                  <span
                  class="ml-2 text-grey-900 font-bold">(Inactive)</span>
                }</span>
                @if (locationHasChildren(l)) {
                  <div class=" bg-standardwhite "
                    (click)="buildLocationDDL(l.LocationID)">
                    <span
                      class="standardTextSize text-offblack hover:hover-for-select bg-grey-300 border-grey-900 border-spacing-2 border-s h-full px-4 flex items-center">Sub
                    Locations</span>
                  </div>
                }
              </div>
            }
            <div class="flex mt-5 mr-2 items-center">
              <p class="">Include Sub Locations:</p>
              <app-toggle-switch [(checked)]="includeSubLocations" class="ml-2"></app-toggle-switch>
            </div>
            @if (true) {
              <div class="mt-6">
                <button class="btn-primary-full max-w-xl" (click)="confirmLocation()"
                  [class.disabled]="!canStart" [disabled]="!isLocationSelected">
                  @if (isLocationSelected) {
                    <span class="standardTextSize">Next ></span>
                  }
                  @if (!isLocationSelected) {
                    <span class="standardTextSize">Choose Location</span>
                  }
                </button>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
@if (showPermissions) {
  <div class="mt-4 px-6">
    @if (false) {
      <h3 class="text-attention-strong">You currently have unsaved changes, remember to save!</h3>
    }
    <input placeholder="Search Users" class="text-box w-full md:w-2/5 mb-1" type="text" (keyup)="filterListByUser()"
      [(ngModel)]="filterUser" />
      <table class="w-full">
        <thead>
          <tr>
            <th colspan="2"></th>
            <th class="border-grey-900 border-2 border-b-[1px] text-lg" colspan="2">{{ 'audit' | customerTerm:true }}</th>
            <th colspan="2" class="border-grey-900 border-2 border-b-[1px]  text-lg">Actions</th>
            <th rowspan="2" class="border-grey-900 border-2  text-lg">Admin</th>
          </tr>
          <tr class="border-b-2 border-grey-900">
            <th class="pr-2 text-left">User</th>
            <th class="pr-2  text-left">Location</th>
            <th class="border-l-2 border-grey-900">Save</th>
            <th class="border-r-2 border-grey-900 border-l-[1px]">View</th>
            <th>Complete</th>
            <th class="border-r-2 border-grey-900  border-l-[1px]">View</th>
          </tr>
        </thead>
        <tbody>
          @for (a of filteredData; track a; let j = $index) {
            <tr
              [ngClass]="{'border-grey-900 border-b-2':isLastUserRow(a.User.UserID,j),'border-grey-900 border-t-2':isFirstUserRow(a.User.UserID,j)}">
              @if (isFirstUserRow(a.User.UserID,j)) {
                <td class="" [rowSpan]="rowCounter(a.User.UserID)">
                  @if (a.Location.LocationLevelID == -1) {
                    <span>{{a.User.DisplayName}}</span>
                  }
                </td>
              }
              <td class="pr-4"
                [ngClass]="{'text-grey-900':!a.Location.HasPermission || !a.Location.Active,'pl-2':(a.Location.LocationLevelSeq) == 1,'pl-4':(a.Location.LocationLevelSeq) == 2,'pl-6':(a.Location.LocationLevelSeq) == 3,'pl-8':(a.Location.LocationLevelSeq) >= 4,'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
                {{a.Location.LocationName}} @if (!a.Location.Active) {
                <span class="text-grey-900"> (Inactive)</span>
              }
            </td>
            <td class="border-l-grey-900 border-l-2"
              [ngClass]="{' cursor-not-allowed':!a.Location.HasPermission,'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center py-1"><app-simple-toggle (isCheckedChange)="updateSimpleSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,1,$event)"
              [(isChecked)]="a.Location.Features.SimpleSaveAudit"></app-simple-toggle></div>
            </td>
            <td
              [ngClass]="{' cursor-not-allowed':!a.Location.HasPermission,'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center py-1"><app-simple-toggle [isDisabled]="a.Location.Features.SimpleSaveAudit" (isCheckedChange)="updateSimpleSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,2,$event)"
              [(isChecked)]="a.Location.Features.SimpleViewAudit"></app-simple-toggle></div>
            </td>
            <td class="border-l-grey-900 border-l-2"
              [ngClass]="{' cursor-not-allowed':!a.Location.HasPermission,'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center py-1"><app-simple-toggle (isCheckedChange)="updateSimpleSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,3,$event)"
              [(isChecked)]="a.Location.Features.SimpleCompleteAction"></app-simple-toggle></div>
            </td>
            <td
              [ngClass]="{' cursor-not-allowed':!a.Location.HasPermission,'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center py-1"><app-simple-toggle [isDisabled]="a.Location.Features.SimpleCompleteAction" (isCheckedChange)="updateSimpleSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,4,$event)"
              [(isChecked)]="a.Location.Features.SimpleViewAction"></app-simple-toggle></div>
            </td>
            <td class="border-x-grey-900 border-x-2"
              [ngClass]="{' cursor-not-allowed':!a.Location.HasPermission,'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center py-1"><app-simple-toggle (isCheckedChange)="updateSimpleSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,5,$event)"
              [(isChecked)]="a.Location.Features.SimpleAdmin"></app-simple-toggle></div>
            </td>
          </tr>
        }
      </tbody>
    </table>
    @if (false) {
      <table>
        <thead>
          <tr>
            <th class="pr-2">User</th>
            <th class="pr-2">Location</th>
            <th class="pr-2">View {{ 'audit' | customerTerm:true }}</th>
            <th class="pr-2">Save {{ 'audit' | customerTerm:true }}</th>
            <th class="pr-2">Edit {{ 'audit' | customerTerm:true }}</th>
            <th class="pr-2">Edit Locations</th>
            <th class="pr-2">Edit Users</th>
            <th class="pr-2">Schedule {{ 'audit' | customerTerm:true }}</th>
            <th class="pr-2">Delete Scheduled {{ 'audit' | customerTerm:true }}</th>
          </tr>
        </thead>
        <tbody>
          @for (a of filteredData; track a) {
            <tr
              [ngClass]="{'border-solid border-t-2 py-4 border-t-offblack':a.Location.LocationLevelID == -1}">
              <td class="pr-4" [ngClass]="{'font-bold':a.User.UserTypeID == 2}">@if (a.Location.LocationLevelID == -1) {
                <span
                >{{a.User.DisplayName}}</span>
              }</td>
              <td class="pr-4"
                [ngClass]="{'text-grey-900':!a.Location.HasPermission || !a.Location.Active,'pl-2':(a.Location.LocationLevelSeq) == 1,'pl-4':(a.Location.LocationLevelSeq) == 2,'pl-6':(a.Location.LocationLevelSeq) == 3,'pl-8':(a.Location.LocationLevelSeq) >= 4,'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
                {{a.Location.LocationName}} @if (!a.Location.Active) {
                <span class="text-grey-900"> (Inactive)</span>
              }
            </td>
            <td class="pr-4  content-center"
              [ngClass]="{'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center ">
                @if (a.Location.HasPermission) {
                  <input type="checkbox" [disabled]="!a.Location.HasPermission || saveStarted"
                    [ngClass]="{'bg-grey-900':a.Location.SubLocationFeatures.ViewAudit && !a.Location.Features.ViewAudit,' cursor-not-allowed':!a.Location.HasPermission}"
                    [checked]="a.Location.Features.ViewAudit"
                    (change)="updateSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,1,$event)" />
                }
              </div>
            </td>
            <td class="pr-4"
              [ngClass]="{'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center ">
                @if (a.Location.HasPermission) {
                  <input type="checkbox" [disabled]="!a.Location.HasPermission || saveStarted"
                    [ngClass]="{'bg-grey-900':a.Location.SubLocationFeatures.SaveAudit && !a.Location.Features.SaveAudit,'cursor-not-allowed':!a.Location.HasPermission}"
                    [checked]="a.Location.Features.SaveAudit"
                    (change)="updateSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,2,$event)" />
                }
              </div>
            </td>
            <td class="pr-4"
              [ngClass]="{'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center ">
                @if (a.Location.HasPermission) {
                  <input type="checkbox" [disabled]="!a.Location.HasPermission || saveStarted"
                    [ngClass]="{'bg-grey-900':a.Location.SubLocationFeatures.EditAudit && !a.Location.Features.EditAudit,'cursor-not-allowed':!a.Location.HasPermission}"
                    [checked]="a.Location.Features.EditAudit"
                    (change)="updateSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,3,$event)" />
                }
              </div>
            </td>
            <td class="pr-4"
              [ngClass]="{'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center ">
                @if (a.Location.HasPermission) {
                  <input type="checkbox" [disabled]="!a.Location.HasPermission || saveStarted"
                    [ngClass]="{'bg-grey-900':a.Location.SubLocationFeatures.EditLocations && !a.Location.Features.EditLocations,' cursor-not-allowed':!a.Location.HasPermission}"
                    [checked]="a.Location.Features.EditLocations"
                    (change)="updateSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,4,$event)" />
                }
              </div>
            </td>
            <td class="pr-4"
              [ngClass]="{'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center ">
                @if (a.Location.HasPermission) {
                  <input type="checkbox" [disabled]="!a.Location.HasPermission || saveStarted"
                    [ngClass]="{'bg-grey-900':a.Location.SubLocationFeatures.EditUsers && !a.Location.Features.EditUsers,' cursor-not-allowed':!a.Location.HasPermission}"
                    [checked]="a.Location.Features.EditUsers"
                    (change)="updateSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,5,$event)" />
                }
              </div>
            </td>
            <td [ngClass]="{'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center ">
                @if (a.Location.HasPermission) {
                  <input type="checkbox" [disabled]="!a.Location.HasPermission || saveStarted"
                    [ngClass]="{'bg-grey-900':a.Location.SubLocationFeatures.ScheduleAudit && !a.Location.Features.ScheduleAudit,' cursor-not-allowed':!a.Location.HasPermission}"
                    [checked]="a.Location.Features.ScheduleAudit"
                    (change)="updateSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,6,$event)" />
                }
              </div>
            </td>
            <td [ngClass]="{'border-solid border-b-[1px] border-b-green-300':a.Location.LocationLevelID == -1}">
              <div class="flex justify-center ">
                @if (a.Location.HasPermission) {
                  <input type="checkbox" [disabled]="!a.Location.HasPermission || saveStarted"
                    [ngClass]="{'bg-grey-900':a.Location.SubLocationFeatures.DeleteScheduledAudit && !a.Location.Features.DeleteScheduledAudit,' cursor-not-allowed':!a.Location.HasPermission}"
                    [checked]="a.Location.Features.DeleteScheduledAudit"
                    (change)="updateSelection(a.User.UserID,a.Location.LocationLevelID,a.Location.LocationID,10,$event)" />
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

</div>
}

</div>
